import { Group, Stack, Title } from "@mantine/core";
import { SimpleBreadcrumbs } from "../../../components/SimpleBreadcrumbs";
import { FormattedMessage, useIntl } from "react-intl";
import { useTRPC } from "../../../trpc";
import { startOfMonth } from "date-fns/startOfMonth";
import { endOfMonth } from "date-fns/endOfMonth";
import { EChartTimeseries } from "../../../components/EChartTimeseries";
import { useQuery } from "@tanstack/react-query";
import { tilesetDashboardLayoutRoute } from "./routes";
import { usePathAccountName } from "../../../hooks/router";
import { useMemoizedBarSeries } from "../../../hooks/chart.js";

export function TilesetUsage() {
  const intl = useIntl();
  const trpc = useTRPC();
  const account = usePathAccountName();
  const { tileset } = tilesetDashboardLayoutRoute.useParams();
  const { dataset } = tilesetDashboardLayoutRoute.useSearch();

  const { data: current } = useQuery(trpc.getTilesetWithVersions.queryOptions({
    account,
    tileset,
    dataset,
  }, {
    refetchInterval: 1000 * 60 * 5,
    refetchOnMount: false,
  }));

  const { data: usage = [] } = useQuery(trpc.getTilesetTileUsage.queryOptions({
    from: startOfMonth(new Date()),
    to: endOfMonth(new Date()),
    interval: "day",
    tilesetId: current?.tileset.id,
  }, {
    enabled: !!current,
    refetchInterval: 1000 * 60 * 5,
    refetchOnMount: false,
  }));

  const usageSeries = useMemoizedBarSeries(usage);

  return (
    <Stack gap={16} px="md" my="md">
      <SimpleBreadcrumbs
        parent={intl.formatMessage({
          defaultMessage: "Usage",
          id: "navigation.usage",
        })}
        current={dataset ? `${dataset} - ${tileset}` : tileset}
        description={
          <FormattedMessage id="text.tilesetUsageDescription" defaultMessage="View your tileset usage." />
        }
      />
      <Stack>
        <Title size="h4">
          <FormattedMessage defaultMessage="Tileset API usage" id="title.tilesetAPIUsage" />
        </Title>
        <Group h="320px">
          <EChartTimeseries
            series={usageSeries}
            xLabel="Date"
            yLabel="Count"
          />
        </Group>
      </Stack>
    </Stack>
  );
}
